module.exports = __webpack_public_path__ + "static/sf_4.625e96f0.png";